import React,{useEffect,useState,Fragment} from 'react';
import {useHistory} from 'react-router-dom';
import {motion} from 'framer-motion';
import styled from 'styled-components';
import Panel from '../components/Panel';
import Content from '../components/Content';
import Progress from '../components/Progress';
import Expanded from '../components/Expanded';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import HomeIcon from '../assets/img/home-icon.svg';

const Question1 = (props) => {

    const [q1,getQ1] = useState(50);
    const [isAnswered,setIsAnswered] = useState(false);
    const history = useHistory();
    const [isExtraOpen, setIsExtraOpen] = useState(false);

    const getInput = e => {
        const t = e.currentTarget.value;
        props.getQ1(t);
    }

    const checkInput = e => {
        setIsAnswered(true)
        e.preventDefault();
    }

    return(
        <QuestionPage className="pink">
            <Panel setBG="bp1"> 
                <div className="process-title">business process #1</div>
            </Panel>
            {!isAnswered ?
                    <Content preAns isExtraOpen={isExtraOpen} setIsExtraOpen={setIsExtraOpen}>
                    <h1 className="main-q">technician dispatch efficiency</h1>
                    <h2 className="question-title">What percent of dispatches result in "no action taken”?</h2>
                    <form onSubmit={checkInput} action="">
                        <br></br>    
                        <br></br>      
                        <input className="default-slider" required onChange={getInput} type="range" min="1" max="100" />  <LivePerc>{props.q1 == undefined || null ? '50' : props.q1}%</LivePerc>
                        <br></br>
                        <CalculateButton />
                    </form>
                </Content>
                :
                <Content preAns={false} isExtraOpen={isExtraOpen} setIsExtraOpen={setIsExtraOpen}>
                    {props.q1 < 12 ?
                    <Fragment>
                    <motion.div initial={{opacity:1,y:'150%'}} animate={{opacity:1,y: '0',transition:{duration:1}}} exit={{opacity:0}}>
                        <h1 className="main-q">technician dispatch efficiency</h1>
                        <div className="determined-benchmark">You are <span>ahead</span> of the industry benchmark</div>
                        <TextInfo>
                            <div> 
                                <p>We found that 12% of dispatches result in no action taken on behalf of the technician, with Amdocs customers typically achieving a rate of 6%.</p>    
                                <p>With the cost of a typical truck roll often exceeding $150 per event, it’s clear that avoiding unnecessary dispatches can play a significant role in improving cost efficiency.</p>
                            </div>
                            <div>
                                <p>This is possible when the service provider can:</p>
                                <ul>
                                    <li><b>Expedite front-step delivery</b> of equipment that could override existing hardware or network issues</li>
                                    <li><b>Enable the contact center</b> with knowledge and tools to handle support issues typically handled by technicians</li>
                                    <li><b>Enhance self-support options</b> that empower customers to resolve more basic issues on their own</li>
                                </ul>
                            </div>
                        </TextInfo>     
                    </motion.div>
                    <Expanded className="ext" isExtraOpen={isExtraOpen} setIsExtraOpen={setIsExtraOpen}>
                    <h1>how Amdocs can help</h1>
                        <p>Our Business Process Services can help you dramatically reduce the rate of dispatches that result in no action taken as well as the overall number of daily dispatches.</p>
                        <p>We do this by:</p>
                        <ul>
                            <li><b>Analyzing</b> the dispatch load and identifying which dispatches can be avoided and handled through the contact center or self-service channels</li>
                            <li><b>Evaluating</b> dispatch requests, engaging with customers, troubleshooting issues and canceling dispatches for tickets that are resolved without requiring a dispatch</li>
                            <li><b>Enhancing</b> data management, alignment, synchronization and integration of customer interaction and dispatch systems, with real-time automation of tasks and trend identification</li>
                        </ul>
                        <NextPage onClick={()=>{history.push('/question2')}}>next question <NextArrow icon={faArrowRight}/></NextPage>
                    </Expanded>                   
                    </Fragment>

                    : props.q1 == 12 ?
                    <Fragment>
                            <motion.div initial={{opacity:1,y:'150%'}} animate={{opacity:1,y: '0',transition:{duration:1}}} exit={{opacity:0}}>
                        <h1 className="main-q">technician dispatch efficiency</h1>
                        <div className="determined-benchmark">You are <span>exactly</span> in line with the industry benchmark</div>
                        <TextInfo>
                            <div> 
                                <p>We found that 12% of dispatches result in no action taken on behalf of the technician, with Amdocs customers typically achieving a rate of 6%.</p>    
                                <p>With the cost of a typical truck roll often exceeding $150 per event, it’s clear that avoiding unnecessary dispatches can play a significant role in improving cost efficiency.</p>
                            </div>
                            <div>
                                <p>This is possible when the service provider can:</p>
                                <ul>
                                    <li><b>Expedite front-step delivery</b> of equipment that could override existing hardware or network issues</li>
                                    <li><b>Enable the contact center</b> with knowledge and tools to handle support issues typically handled by technicians</li>
                                    <li><b>Enhance self-support options</b> that empower customers to resolve more basic issues on their own</li>
                                </ul>
                            </div>
                        </TextInfo>
                        </motion.div>
                        <Expanded isExtraOpen={isExtraOpen} setIsExtraOpen={setIsExtraOpen}>
                    <h1>how Amdocs can help</h1>
                        <p>Our Business Process Services can help you dramatically reduce the rate of dispatches that result in no action taken as well as the overall number of daily dispatches.</p>
                        <p>We do this by:</p>
                        <ul>
                            <li><b>Analyzing</b> the dispatch load and identifying which dispatches can be avoided and handled through the contact center or self-service channels</li>
                            <li><b>Evaluating</b> dispatch requests, engaging with customers, troubleshooting issues and canceling dispatches for tickets that are resolved without requiring a dispatch</li>
                            <li><b>Enhancing</b> data management, alignment, synchronization and integration of customer interaction and dispatch systems, with real-time automation of tasks and trend identification</li>
                        </ul>
                        <NextPage onClick={()=>{history.push('/question2')}}>next question <NextArrow icon={faArrowRight}/></NextPage>
                    </Expanded>          
                    </Fragment>
                    : props.q1 > 12 ?
                    <Fragment>
                           <motion.div initial={{opacity:1,y:'150%'}} animate={{opacity:1,y: '0',transition:{duration:1}}} exit={{opacity:0}}>
                    <h1 className="main-q">technician dispatch efficiency</h1>
                        <div className="determined-benchmark">You are <span>behind</span> the industry benchmark</div>
                        <TextInfo>
                            <div> 
                                <p>We found that 12% of dispatches result in no action taken on behalf of the technician, with Amdocs customers typically achieving a rate of 6%.</p>    
                                <p>With the cost of a typical truck roll often exceeding $150 per event, it’s clear that avoiding unnecessary dispatches can play a significant role in improving cost efficiency.</p>
                            </div>
                            <div>
                                <p>This is possible when the service provider can:</p>
                                <ul>
                                    <li><b>Expedite front-step delivery</b> of equipment that could override existing hardware or network issues</li>
                                    <li><b>Enable the contact center</b> with knowledge and tools to handle support issues typically handled by technicians</li>
                                    <li><b>Enhance self-support options</b> that empower customers to resolve more basic issues on their own</li>
                                </ul>
                            </div>
                        </TextInfo>
                        </motion.div>
                        <Expanded isExtraOpen={isExtraOpen} setIsExtraOpen={setIsExtraOpen}>
                    <h1>how Amdocs can help</h1>
                        <p>Our Business Process Services can help you dramatically reduce the rate of dispatches that result in no action taken as well as the overall number of daily dispatches.</p>
                        <p>We do this by:</p>
                        <ul>
                            <li><b>Analyzing</b> the dispatch load and identifying which dispatches can be avoided and handled through the contact center or self-service channels</li>
                            <li><b>Evaluating</b> dispatch requests, engaging with customers, troubleshooting issues and canceling dispatches for tickets that are resolved without requiring a dispatch</li>
                            <li><b>Enhancing</b> data management, alignment, synchronization and integration of customer interaction and dispatch systems, with real-time automation of tasks and trend identification</li>
                        </ul>
                        <NextPage onClick={()=>{history.push('/question2')}}>next question <NextArrow icon={faArrowRight}/></NextPage>
                    </Expanded>          
                    </Fragment>
                    : 
                    <Fragment></Fragment>
                    }
                </Content>
            }
           
           <Progress prog={20} />

        </QuestionPage>
    )
}

const QuestionPage = styled(motion.div)`
    width: 100%;
    height: 100%;
    overflow-x: hidden !important;
    display: flex;

    @media (max-width: 1060px) {
        flex-direction: column;
        height: auto;
    }

`;

const IndustryBenchmark = styled.h3`
    font-family: 'MarkPro-ExtraLight';
    margin-bottom: 20px;
`;

const TextInfo = styled.div`
    display: flex;


    ul{
        font-family: 'MarkPro-Light';
        li{
            margin: 15px 0 15px 17px;
            font-size: 18px;
        }
    }

    @media (max-width: 1060px) {
        flex-direction: column;

        ul{
            li{
                margin-left: 17px;
            }
        }
    }

    div{
        flex: 1;
        margin-right: 50px;
    }
    

`;


const NextPage = styled.div`
   font-family: 'MarkPro-Bold';
    color: #fff;
    background: #EAB330;
    text-align: center;
    position: fixed;
    bottom: 60px;
    right: 0;
    font-size: 1.5em;
    padding: 15px;
    cursor: pointer;
    z-index:1000;

    @media (max-width: 1060px) {
        display: block;
        position: static;
        margin-top: 30px;
    }
`;

const NextArrow = styled(FontAwesomeIcon)`
    margin-left: 10px;
`;



const CalculateButton = styled.input.attrs({ 
    type: 'submit',
    value: 'submit'
  })`
    background: #333147;
    color: #fff;
    cursor: pointer;
    margin-bottom: 0;
    border-color: transparent;
    box-shadow: 0px;
    outline: none;
    text-align: center;
    font-family: 'MarkPro-Bold';
    padding: 10px;
    font-size: 1.3em;
    width: 130px;
    margin-top: 30px;
  `


const LivePerc = styled.span`
    font-family: 'MarkPro-Bold';
    font-size: 2em;
    margin-left: 30px;


    @media (max-width: 1060px) {
        margin-left: 0;
    }

`;


const DummyContainer = styled(motion.div)`
    display: contents;
`;

const HomeButton = styled.div`
    display: block;
    width: 70px; 
    height: 70px;
    border-radius: 100px;
    position: absolute;
    top: 20px;
    left: 20px;
    background: url(${HomeIcon}) no-repeat center center;
    background-size: 60%;
    background-color: #333147;
    cursor: pointer;

    @media (max-width: 1060px) {
        width: 62px;
        height: 62px;
    }

`;

export default Question1;